import { EmployeeAvatar } from "@/components/employee/EmployeeAvatar.tsx";
import { UserCard } from "@/components/user-card/UserCard.tsx";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { ApiPreboardingManager } from "@/types/preboarding.types.ts";
import { useTranslation } from "react-i18next";

interface PreboardingManagerCardProps {
  manager: ApiPreboardingManager;
}

export function PreboardingManagerCard({ manager }: PreboardingManagerCardProps) {
  const { t } = useTranslation();
  const { renderEmployeeName } = useFormatter();

  return (
    <UserCard
      size={"md"}
      title={renderEmployeeName(manager)}
      caption={manager.job_profile_title ?? t("core:my_manager")}
      avatarElement={<EmployeeAvatar employee={manager} size={"2xl"} />}
    />
  );
}
